API_URL_BASE = '/api/'

AppConfig =

  IS_DEBUG: false

  BREAKPOINT_1:
    max: 'auto'
    min: 980

  BREAKPOINT_2:
    max: 979
    min: 768

  BREAKPOINT_3:
    max: 767
    min: 0

  API_URL:
    GET_TOP_NEW_LIST:          API_URL_BASE + 'get_top_new_list/'
    GET_ARTICLE_CATEGORY_LIST: API_URL_BASE + 'get_article_category_list/'
    GET_ARTICLE_TAG_LIST:      API_URL_BASE + 'get_article_tag_list/'
    GET_SEARCH_KEYWORD_LIST:   API_URL_BASE + 'get_search_keyword_list/'
    GET_TOPICS_LIST:           API_URL_BASE + 'get_topics_list/'
    GET_TOP_NEW_REACTION:      API_URL_BASE + 'get_top_new_reaction/'
    GET_CONTENTS_REACTION:     API_URL_BASE + 'get_contents_reaction/'
    GET_TOPICS_REACTION:       API_URL_BASE + 'get_topics_reaction/'
    GET_COMMENT_REACTION:      API_URL_BASE + 'get_comment_reaction/'
    COMMENT_REGIST:            API_URL_BASE + 'comment_regist/'
    COMMENT_DELETE:            API_URL_BASE + 'comment_delete/'
    NICE_REGIST:               API_URL_BASE + 'nice_regist/'
    GET_SEND_COMMENT:          API_URL_BASE + 'get_send_comment/'
    GET_RECEIVE_COMMENT:       API_URL_BASE + 'get_receive_comment/'
    GET_SEND_NICE:             API_URL_BASE + 'get_send_nice/'
    GET_RECEIVE_NICE:          API_URL_BASE + 'get_receive_nice/'
    TOPPICS_REPORT:            API_URL_BASE + 'topics_report/'
    GET_RECOMMENTD_LIST:       API_URL_BASE + 'get_recommend_list/'
    NICE_READ_UPDATE:          API_URL_BASE + 'nice_read_update/'
    COMMENT_READ_UPDATE:       API_URL_BASE + 'comment_read_update/'

module.exports = AppConfig



// WEBPACK FOOTER //
// ./src/scripts/AppConfig.coffee